module.exports = __webpack_public_path__ + "static/media/palmTreeFire.8a129ee4.png";